let products = [
  {
    id: 0,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCC1LL/A",
    ram: "6 GB",
    screenSize: "6.7",
    camera: "12 Megapixel",
    condition: "New",
    title: "Unlocked Apple iPhone 12",
    color: ["Black", "Blue", "Green"],
    capacity: ["128GB", "256GB", "512GB"],
    img: "/iphone-12.jpeg",
    description: `
iPhone 12 5G to download movies on the fly and stream high-quality video. Beautifully bright 6.1inch Super Retina XDR display. Ceramic Shield with 4x better drop performance. Incredible low-light photography with Night mode on all cameras. Cinema grade Dolby Vision video recording, editing, and playback. Powerful A14 Bionic chip. And new MagSafe accessories for easy attach and faster wireless charging. Let the fun begin`,
    price: 990.0,
    image: {
      Black: ["/iphone-12.jpeg", "/iphone-12_2.jpeg", "/iphone-12_3.jpeg"],
      Blue: [
        "/iphone-12_blue.jpeg",
        "/iphone-12_blue_2.jpeg",
        "/iphone-12_blue_3.jpeg",
      ],
      Green: [
        "/iphone-12_green.jpeg",
        "/iphone-12_green_2.jpeg",
        "/iphone-12_green_3.jpeg",
      ],
    },
  },
  {
    id: 1,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCC3LL/A",
    ram: "6 GB",
    screenSize: "6.1",
    camera: "12 Megapixel",
    condition: "New",
    title: "Unlocked Apple iPhone 11",
    color: ["Black", "White"],
    capacity: ["128GB", "256GB"],
    img: "/iphone-11_black.png",
    description: `
    Take it to 11. Just the right amount of everything. Colorful. Powerful. Essential. See the whole picture with Ultra Wide. iPhone 11. An essential upgrade Shoot 4K videos, beautiful portraits, and sweeping landscapes with the all-new dual-camera system. Capture your best low-light photos with Night mode. See true-to-life color in your photos, videos, and games on the 6.1-inch Liquid Retina display. Experience unprecedented performance with A13 Bionic for gaming, augmented reality (AR), and photography. Do more and power less with all-day battery life and worry less with water resistance up to 2 meters for 30 minutes.6.1-inch Liquid Retina HD LCD display Water and dust resistant (2 meters for up to 30 minutes, IP68) Dual-camera system with 12MP Ultra Wide and Wide cameras; Night mode, Portrait mode, and 4K video up to 60fps

    6.1-inch Liquid Retina HD LCD display`,
    price: 890.0,
    image: {
      Black: [
        "/iphone-11_black.png",
        "/iphone-11_black_2.jpeg",
        "/iphone-11_black_3.jpeg",
      ],
      White: [
        "/iphone-11_white.png",
        "/iphone-11_white_2.png",
        "/iphone-11_white_3.png",
      ],
    },
  },
  {
    id: 2,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCF4LL/A",
    ram: "6 GB",
    screenSize: "6.1",
    camera: "12 Megapixel",
    condition: "New",
    title: "Unlocked Apple iPhone XR",
    color: ["Black", "Red", "Blue"],
    capacity: ["128GB", "256GB", "512GB"],
    img: ["/iphone-xr_black.jpeg"],
    description: `
    iPhone Xr features the most advanced LCD in a smartphone—a 6.1-inch Liquid Retina display with industry-leading color accuracy and an innovative backlight design that allows the screen to stretch into the corners.1 Six stunning new finishes. Advanced Face ID lets you securely unlock your iPhone, log in to apps, and pay with just a glance. The A12 Bionic chip with next-generation Neural Engine uses real-time machine learning to transform the way you experience photos, gaming, augmented reality, and more. A breakthrough 12MP camera system with Portrait mode, Portrait Lighting, enhanced bokeh, and all-new Depth Control. Water resistance.2 And iOS 12—the most advanced mobile operating system in the world—with powerful new tools that make iPhone more personal than ever.
    `,
    price: 720.0,
    image: {
      Black: [
        "/iphone-xr_black.jpeg",
        "/iphone-xr_black_2.jpeg",
        "/iphone-xr_black_3.jpeg",
      ],
      Blue: [
        "/iphone-xr_blue.jpeg",
        "/iphone-xr_blue_2.jpeg",
        "/iphone-xr_blue_3.jpeg",
      ],
      Red: [
        "/iphone-xr_red.jpeg",
        "/iphone-xr_red_2.jpeg",
        "/iphone-xr_red_3.jpeg",
      ],
    },
  },
  {
    id: 3,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCC1LL/V",
    ram: "8 GB",
    screenSize: "11.0",
    camera: "12 Megapixel",
    condition: "New",
    title: "Unlocked Apple IPad Pro",
    color: ["Black", "Silver"],
    capacity: ["256GB", "512GB"],
    img: "/ipad_gray.jpeg",
    description: `
    This is the new iPad Pro. It has the world's most advanced mobile display. It has pro cameras that can transform reality. It's so fast most PC laptops can't catch up. And you can use it with touch, pencil, keyboard, and now mouse or trackpad.
    `,
    price: 749.0,
    image: {
      Black: ["/ipad_gray.jpeg", "/ipad_gray-2.jpeg", "/ipad_gray-3.jpeg"],
      Silver: ["/ipad_silver.jpeg", "/ipad_gray-2.jpeg", "/ipad_gray-3.jpeg"],
    },
  },
  {
    id: 4,
    brand: "Samsung",
    os: "ANDROID",
    mNumber: "SM-G973U",
    ram: "8 GB",
    screenSize: "6.1",
    camera: "12 Megapixel",
    condition: "New",
    title: " Samsung Galaxy S10",
    color: ["Black", "White"],
    capacity: ["128GB"],
    img: "/s10_black.jpeg",
    description: `
    Experience the Galaxy S10 in Prism Black on America’s largest and most dependable networks with Straight Talk. Capture and share every moment with an ultra-wide lens and never miss out with next-level battery intelligence. Get the talk, text & data you want without for less. No contract. No compromise.
    `,
    price: 749.0,
    image: {
      Black: ["/s10_black.jpeg", "/s10_black_2.jpeg", "/s10_black_3.jpeg"],
      White: ["/s10_white.jpeg", "/s10_white_2.jpeg", "/s10_white_3.jpeg"],
    },
  },
  {
    id: 5,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCC1LL/ZQ",
    ram: "1 GB",
    screenSize: "1.78",
    condition: "New",
    title: "Apple Watch Series 6",
    color: ["Black", "White"],
    capacity: [],
    img: "/watch_black_1.jpeg",
    description: `
    Apple Watch Series 6 lets you measure your blood oxygen level with a revolutionary new sensor and app. Take an ECG from your wrist. See your fitness metrics on the enhanced Always-On Retina display, now 2.5x brighter outdoors when your wrist is down. Set a bedtime routine and track your sleep. And with cellular service, you can go without your phone. It's the ultimate device for a healthier, more active, more connected life.
    `,
    price: 629.0,
    image: {
      Black: ["/watch_black_1.jpeg", "/watch_black_2.jpeg"],
      White: ["/watch-white_1.jpeg", "/watch-white_2.jpeg"],
    },
  },
  {
    id: 6,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCC1LL/ZQS",
    condition: "New",
    title: "Apple AirPods Pro",
    color: ["Black", "White"],
    capacity: [],
    img: "/pods-1.jpeg",
    description: `
    Active Noise Cancellation for immersive sound. Transparency mode for hearing and connecting with the world around you. (1)A more customizable fit for all-day comfort. Sweat and water resistant
    All in a super light, (2)In-ear headphone that?s easy to set up with all your Apple devices.
    `,
    price: 197.0,
    image: {
      Black: ["/pods-1.jpeg", "/pods_black-2.jpeg"],
      White: ["/pods-1.jpeg", "/pods-2.jpeg"],
    },
  },
  {
    id: 7,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCC9LL/FHS",
    condition: "New",
    title: "Apple HomePod",
    color: ["Gray", "White"],
    capacity: [],
    img: "/homepod_gray.jpeg",
    description: `
    Jam-packed with innovation, HomePod mini fills the entire room with rich 360-degree audio. Place multiple speakers around the house for a connected sound system. And with Siri, your favorite do-it-all intelligent assistant helps with everyday tasks and controls your smart home privately and securely.
    `,
    price: 99.0,
    image: {
      Gray: ["/homepod_gray.jpeg", "/homepod.jpeg"],
      White: ["/homepod_white.jpeg", "/homepod.jpeg"],
    },
  },
  {
    id: 8,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCD7LL/MKUQS",
    condition: "New",
    title: "Apple Tv 4K",
    color: ["Black"],
    capacity: [],
    img: "/tv_1.jpeg",
    description: `
    Apple TV 4K makes your favorite TV shows and movies even more amazing. Videos play in stunning detail with picture quality that’s more true to life. Find what you want instantly with the Apple TV Remote.* You can even share photos you take with your iPhone on the big screen. 4K HDR is here. And it’s brilliant.
    `,
    price: 158.0,
    image: {
      Black: ["/tv_1.jpeg", "/tv_2.jpeg"],
    },
  },
  {
    id: 9,
    brand: "Apple",
    title: "Apple Pro Display",
    os: "IOS",
    mNumber: "MGCDU6LL/JSFGZQS",
    condition: "New",
    color: ["Silver"],
    capacity: [],
    img: "/pro-display_1.jpg",
    description: `
    Introducing Apple Pro Display XDR. A massive 32" LCD display with Retina 6K resolution and 20.4 million pixels.¹ Gorgeous P3 wide color and 10-bit depth for over a billion colors and very smooth gradients. Extreme dynamic range (XDR) with quality brightness and contrast for vivid, true-to-life images. Extra-wide viewing angle and reference modes based on industry standards. Pair with the modular Pro Stand for adjustability and flexibility on the go, or use the VESA mount adapter to attach to VESA mounts or arms. It's a groundbreaking display built for the most demanding professionals. Stand sold separately.
    `,
    price: 4999.99,
    image: {
      Silver: ["/pro-display_1.jpg", "/pro-display_2.jpg"],
    },
  },
  {
    id: 10,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCD731LL/W",
    ram: "8 GB",
    screenSize: "13.3 in",
    processorT: "Intel Core i5 8th Gen.",
    processorS: "1.46 GHz",
    condition: "New",
    title: "Apple Macbook Pro 16",
    capacity: ["512GB", "1000GB"],
    img: "/mac-pro_gray.jpg",
    description: `
    Available in silver, space gray, and gold, the latest MacBook Air features a stunning Retina display with True Tone technology, Touch ID, a backlit Magic Keyboard, and a Force Touch trackpad - all housed in a thin and light iconic wedge design made from 100 percent recycled aluminum.² And with 11-hour battery life, it's a do-it-all notebook that goes all day long.
    `,
    price: 2199.0,
    image: {
      Gray: [
        "/mac-pro_gray.jpg",
        "/mac-pro_gray-2.jpg",
        "/mac-pro_gray-3.jpeg",
      ],
    },
    color: ["Gray"],
  },

  {
    id: 11,
    brand: "Apple",
    os: "IOS",
    mNumber: "MGCD731LL/W",
    ram: "8 GB",
    screenSize: "13.3 in",
    processorT: "Intel Core i5 8th Gen.",
    processorS: "1.46 GHz",
    condition: "New",
    title: "Apple Macbook Air 13.3",
    color: ["Gray", "Gold"],
    capacity: ["256GB", "512GB"],
    img: "/mac-air_gray.jpg",
    description: `

Available in space gray, and gold, the latest MacBook Air features a stunning Retina display with True Tone technology, Touch ID, a backlit Magic Keyboard, and a Force Touch trackpad - all housed in a thin and light iconic wedge design made from 100 percent recycled aluminum.² And with 11-hour battery life, it's a do-it-all notebook that goes all day long.
`,
    price: 899.0,
    image: {
      Gray: ["/mac-air_gray.jpg", "/mac-air_gray-2.jpg", "/mac-air_gray-3.jpg"],
      Gold: ["/mac-air_gold.jpg", "/mac-air_gold-2.jpg", "/mac-air_gold-3.jpg"],
    },
  },
];
export default products;
